const SMDIalogControl = {
  open: () => {},
  close: () => {},
  setDialogData: () => {},
};

export default SMDIalogControl;

export const SMChatDIalogControl = {
  open: () => {},
  close: () => {},
  setDialogData: () => {},
};

export const SMLocationDIalogControl = {
  open: () => {},
  close: () => {},
  setDialogData: () => {},
};

export const SMPromptControl = {
  open: () => {},
  close: (onClose) => {
    onClose();
    this.title = '';
    this.content = [];
    this.actions = [];
  },
  title: '',
  content: [],
  actions: [],
};

export const SMConfirmDialogControl = {
  open: () => {},
  close: () => {},
  setDialogData: () => {},
}

